import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#FFFFFF',
    },

    st1: {
    },

    st2: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st3: {
        clipPath: 'url(#SVGID_2_)',
    },

    st4: {
        fill: 'none',
        stroke: '#FFFFFF',
    },
}));
